import i18n from 'i18n';
import { ValueFormatterParams } from '@ag-grid-enterprise/all-modules';
import { AuditService } from 'shared/userAudit/audit-constants';

export function stateValue(value:string): string {

  const VALUES_MAPS = {
    [AuditService.AF]: i18n.t('audit.userAudit.grid.accessFunction'),
    [AuditService.CF]: i18n.t('audit.userAudit.grid.collectionFunction'),
    [AuditService.CF_GROUP]: i18n.t('audit.userAudit.grid.collectionFunctionGroup'),
    [AuditService.DISTRIBUTOR_CONFIGS]: i18n.t('audit.userAudit.grid.distributorConfigs'),
    [AuditService.PROCESS_OPTIONS]: i18n.t('audit.userAudit.grid.processOptions'),
    [AuditService.DIALED_DIGIT_EXTRACTION_SERVER]: i18n.t('audit.userAudit.grid.dialedExtrServer'),
    [AuditService.SECURITY_INFO]: i18n.t('audit.userAudit.grid.securityInfo'),
    [AuditService.TARGET_TEMPLATE_PER_ACCESS_FUNCTION]: i18n.t('audit.userAudit.grid.targetTempAF'),
    [AuditService.UTIMACO_PACKET_SWITCH]: i18n.t('audit.userAudit.grid.ultimaco'),
    [AuditService.NETWORK]: i18n.t('audit.userAudit.grid.network'),
  };

  type ValuesMap = typeof VALUES_MAPS;
  const key = value as keyof ValuesMap;
  return VALUES_MAPS[key] || value;
}

export default function stateValueFormatter({ value }: Partial<ValueFormatterParams>): string {
  return stateValue(value);
}
